import React from 'react';
import { Check } from 'lucide-react';

interface Props {
  steps: string[];
  current: number;
}

const StepIndicator: React.FC<Props> = ({ steps, current }) => {
  return (
    <div className="flex items-center gap-2">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <React.Fragment key={label}>
            <div className="flex items-center gap-2">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold border-2 transition-colors ${
                  done
                    ? 'bg-cargo-success border-cargo-success text-white'
                    : active
                    ? 'border-cargo-accent text-cargo-accent bg-cargo-accent/10'
                    : 'border-cargo-border text-cargo-muted bg-transparent'
                }`}
              >
                {done ? <Check className="w-4 h-4" /> : i + 1}
              </div>
              <span
                className={`text-sm font-medium hidden md:block ${
                  active ? 'text-cargo-text' : done ? 'text-cargo-success' : 'text-cargo-muted'
                }`}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-1 rounded ${
                  done ? 'bg-cargo-success' : 'bg-cargo-border'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
